import React from "react";

class InputBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      animation: "idle",
      state: null
    }
    this.setAnimation = this.setAnimation.bind(this);
    this.clear = this.clear.bind(this);
  }

  componentDidMount() {
    this.props.setAnimation(this.setAnimation);
    this.props.clear(this.clear);
  }

  setAnimation(animation) {
    this.setState({animation: animation});
  }

  clear() {
    this.setState({
      animation: "idle",
      state: null
    });
  }

  handleAnimationEnd(e) {
    if (e.animationName === "PopIn") {
      this.setState({animation: "idle"});
    } else if (e.animationName === "FlipIn") {
      this.setState({
        animation: "flip-out",
        state: "green"
      });
      this.props.flipNext();
    } else if (e.animationName === "FlipOut") {
      this.setState({ animation: "idle" });
      this.props.doBounce();
    }
  }

  render() {
    return (
      <div
        className="square input-box"
        data-state={this.state.state != null ? this.state.state : this.props.letter == null ? "empty" : "input"}
        data-animation={this.state.animation}
        onAnimationEnd={(e) => this.handleAnimationEnd(e)}
      >
        {this.props.letter}
      </div>
    );
  }
}

export default InputBox;